import _ from 'lodash';
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { setStatusCamapign, loadEditCampaignList } from '../../features/campaign.actions';
import { selectCampaignList} from '../../features/campaign.selectors';
import { CAMPAIGN_TYPE, CAMPAIGN_TYPE_NAME, AUCTION_TYPE } from 'app/virtual-event/virtual-event.enums';
import { UntypedFormGroup } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { SharedService } from 'app/virtual-event/services/shared.service';
import { Subject } from 'rxjs';

import { CampaignService } from '../../services/campaign.service';
import { MdbTabsComponent } from 'mdb-angular-ui-kit/tabs';
import { CampaignListTabsService } from '../../services/campaign-list-tabs.service';
import { RouteReuseStrategyService } from 'app/router-wrapper/services/route-reuse-strategy-service/route-reuse-strategy-service.service';
import { CampaignListTabsStepService } from '../../services/campaign-list-tabs-step.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-campaign-list',
  templateUrl: './campaign-list.component.html',
  styleUrls: ['./campaign-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CampaignListComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('tabs')
  set tabs(tabs: MdbTabsComponent) {
    this.tabsService.tabs = tabs;
  };
  get tabs(): MdbTabsComponent {
    return this.tabsService.tabs;
  }
  
  public campaigns$ = this.store.pipe(
    select(selectCampaignList)
  );
  public CAMPAIGN_TYPE = CAMPAIGN_TYPE;

  public form: UntypedFormGroup = null;

  public allCampaignList = [];
  public activeCampaignList = [];
  public notActiveCampaignList = [];
  public expiredCampaignList = []
  public deactivatedCampaignList = [];
  public notStartedCampaignList = [];
  public archivedCampaignList = [];
  public user = null;
  public popoverButtonHTML = '<span class="badge-warning caption custom-budge d-flex align-items-center justify-content-center position-absolute">Access limited to certain campaigns.</span>'
  public popoverHTML = '';
  public access = null;
  public campLength = 0;


  
  public takeUntilSubject: Subject<any> = new Subject();
  public takeUntilRouteReuseStrategySubject: Subject<any> = new Subject();
  
  public isProduction = false;

  constructor(
    private router: Router,
    private store: Store,
    private sharedService: SharedService,
    private campaignService: CampaignService,
    public tabsService: CampaignListTabsService,
    public tabsStepService: CampaignListTabsStepService,
    private routeReuseStrategyService: RouteReuseStrategyService,
  ) {
    this.isProduction = window['isProduction'];
    this.tabsService.lastStep = 3;

    switch(tabsStepService.step) {
      case 0:
      case 1:
        this.campaignService.statusFilter = 0;
        break;
      case 2:
        this.campaignService.statusFilter = 1;
        break;
    }
  }

  ngOnInit(): void {
    this.routeReuseStrategyService.status = true;
    this.routeReuseStrategyService.routeReuseStrategySubject.pipe(
      takeUntil(this.takeUntilRouteReuseStrategySubject)
    ).subscribe(() => {
      this.takeUntilSubject.next(null);
      this.takeUntilSubject.complete();
      this.takeUntilSubject = new Subject();

      this.ngAfterViewInit();
    });
    this.user = window['localOrgData'].user


    if(this.user.loggedInUser){
      const { access } = this.user.loggedInUser ? this.user.loggedInUser: {
        access: [1]
      };
          if(access[0] == 2 && this.user.loggedInUser.campaigns.length !== 0){
            this.popoverHTML = `
            <div class="d-flex flex-column">
              <span class="body-1"><b>Role: </b>Campaign Manager</span>
              <span class="body-1 mb-2"><b>Campaigns: </b>${this.user.loggedInUser.campaigns.length} Campaigns</span>
              <span class="body-1">You will have access to the new campaigns created by you.</span>
            </div>`
          }
    }
}

  ngAfterViewInit(): void {
    if(this.sharedService.token) {
      this.store.dispatch({
        type: loadEditCampaignList.type,
        payload: this.sharedService.token
      });
    }

    this.campaigns$.pipe(
      takeUntil(this.takeUntilSubject)
    ).subscribe((list) => {
      this.allCampaignList = this.getFilteredCampaignList(list, null);
      this.activeCampaignList = this.getFilteredCampaignList(list, 0);
      this.notActiveCampaignList = this.getFilteredCampaignList(list, [1,2,3]);
      this.expiredCampaignList = this.getFilteredCampaignList(list, 1);
      this.deactivatedCampaignList = this.getFilteredCampaignList(list, 2);
      this.notStartedCampaignList = this.getFilteredCampaignList(list, 3);
      this.archivedCampaignList = this.getFilteredCampaignList(list, 5);
    });
  }

  ngOnDestroy(): void {
    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();

    this.tabsService.status = false;
    this.tabsService.step = 0;
    this.takeUntilRouteReuseStrategySubject.next(null);
    this.takeUntilRouteReuseStrategySubject.complete();

    this.campaignService.statusFilter = 0;

    this.routeReuseStrategyService.status = false;
  }

  onTabChange(event) {

    if(this.tabsService.step == 3){
      this.tabsService.onTabChange(event);
      return;
    }

    this.tabsService.onTabChange(event);

    if(event.index == 3){
      this.tabsService.setActiveTab(this.tabsService.prevStep);
      return
    }

    this.store.dispatch({
      type: loadEditCampaignList.type,
      payload: this.sharedService.token
    });
  }

  onClickDownload(campaign) {
    window['orgMain'].downloadCallback.call(campaign);
  }

  activateCampaign(campaign) {
    this.store.dispatch({
      type: setStatusCamapign.type,
      payload: { campaignId: campaign.id, newStatus: 0 }
    });
  }

  deleteCampaign(campaign) {
    this.store.dispatch({
      type: setStatusCamapign.type,
      payload: { campaignId: campaign.id, newStatus: 2 }
    });
  }

  getCampaignImageUrl(campaign) {
    return campaign.imageUrl || "/images/org_logo_default_v2.svg";
  }

  getCampaignType(campaign) {
    switch(campaign.type) {
      case CAMPAIGN_TYPE.AUCTION:
        return this.isSilentAuction(campaign) ?
          CAMPAIGN_TYPE_NAME.SILENT_AUCTION:
          CAMPAIGN_TYPE_NAME.LIVE_AUCTION;
      case CAMPAIGN_TYPE.DONATE:
        return CAMPAIGN_TYPE_NAME.DONATION;
      case CAMPAIGN_TYPE.MERCHANDISE:
        return CAMPAIGN_TYPE_NAME.MERCHANDISE;
      case CAMPAIGN_TYPE.HINDU_TEMPLE_PUJA:
        return CAMPAIGN_TYPE_NAME.HINDU_TEMPLE_PUJA;
      case CAMPAIGN_TYPE.LAST_HERO:
        return CAMPAIGN_TYPE_NAME.LAST_HERO;
      case CAMPAIGN_TYPE.LONG_PLEDGE:
        return CAMPAIGN_TYPE_NAME.LONG_PLEDGE;
      case CAMPAIGN_TYPE.PEER_TO_PEER:
        return CAMPAIGN_TYPE_NAME.PEER_TO_PEER;
      case CAMPAIGN_TYPE.TICKETING:
        return CAMPAIGN_TYPE_NAME.TICKETING;
      case CAMPAIGN_TYPE.PARTY_SIGNUP:
        return CAMPAIGN_TYPE_NAME.PARTY_SIGNUP;
      case CAMPAIGN_TYPE.PARTY_SIGNUP:
        return CAMPAIGN_TYPE_NAME.PARTY_SIGNUP;
      case CAMPAIGN_TYPE.IN_KIND:
        return CAMPAIGN_TYPE_NAME.IN_KIND;
    }
    return CAMPAIGN_TYPE_NAME.NONE;
  }

  isSilentAuction(campaign) {
    const type = _.get(campaign, 'campaignTypeData.auctionType', 1);
    return _.isEqual(AUCTION_TYPE.SILENT, type);
  }

  isTicketing(campaign) {
    return this.getCampaignType(campaign) === CAMPAIGN_TYPE_NAME.TICKETING;
  }

  getQRUrl(campaign) {
    const handle = _.get(window['localOrgData'], 'user.handle', 'handle');
    const intid = _.get(campaign, 'intid', 0);
    return window.location.protocol + "//" + window.location.hostname + "/@" + handle + "@" + intid;
  }

  getQRImageUrl(campaign) {
    return "/api/pp_code?pp=" + campaign.id;
  }

  getFilteredCampaignList(campaigns, status) {
    const list = _.isNull(status) ? campaigns: _.filter(campaigns, campaign => {
      if(_.isArray(status)) {
        return _.indexOf(status, campaign.status) < 0 ? false: true;
      }
      return _.isEqual(campaign.status, status);
    }) || [];
    return _.sortBy(list, [function(campaign) { return -campaign.updated; }]);
  }


  onEditCampaign(campaign) {
    let name = null;
    switch(campaign.type) {
      case 0:
        name = 'donation';
        break;
      case 1:
        name = 'merchandise';
        break;
      case 3:
        name = 'hindu-temple-puja';
        break;
      case 4:
        name = 'auction';
        break;
      case 5:
        name = 'party-signup';
        break;
      case 6:
        name = 'ticketing';
        break;
      case 7:
        name = 'long-pledge';
        break;
      case 8:
        name = 'peer-to-peer-fundraising';
        break;
      case 9:
        name = 'last-hero';
        break;
      case 10:
        name = 'in-kind';
        break;
    }

    this.router.navigateByUrl(`campaign/${name}/${campaign.id}`);
  }


  createNewCampaign() {
    this.router.navigateByUrl(`campaign/select-type`);
  }

  togglePopover(popover, campaign) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open({ campaign });
    }
  }

}
